import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { ReactiveFormsModule } from '@angular/forms'; 

@Component({
  selector: 'app-oauth-realm-properties',
  templateUrl: './oauth-realm-properties.component.html',
  styleUrls: ['./oauth-realm-properties.component.scss']
})
export class OauthRealmPropertiesComponent implements OnInit {

  showPopup: any = false;
  property: any;
  propertyName: any;
  propertyValue: any;
  oauthRealmId:any;
  idpropertyData:any;
  nameError:any = false;
  valueError:any = false;
  charNum = false; 
  charValue = false;
  duplicateName = false; 
  constructor(private service: ApifirstService, private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.showPopup = false
    this.service.propertyData.subscribe((data) => {
      this.property = data
      console.log(this.property, "property")
    })

    this.service.IDpropertyData.subscribe((data)=>{
      this.idpropertyData = data
      console.log(this.idpropertyData,"id property")
    })
  }
  openPopUp(contentRegPopup: any) {
    this.showPopup = true;
    this.nameError = false;
    this.valueError = false;
    this.charNum = false; 
    this.charValue = false;
    this.duplicateName = false; 
    this.propertyName = '';
    this.propertyValue = '';
    this.modalService.open(contentRegPopup, {});
  }
  addProperty() {
    this.oauthRealmId = this.idpropertyData
    console.log(this.oauthRealmId, "property.oauth_realm_id")
    if(this.propertyName == null || this.propertyName == undefined || this.propertyName.length == 0){
      this.nameError = true;
    }
    else{
      this.nameError = false;
    }
    if(this.propertyValue == null || this.propertyValue == undefined || this.propertyValue.length == 0){
      this.valueError = true;
    }
    else{
      this.valueError = false;
    }
    for(let i of this.property)
    {
      if (i.name == this.propertyName)
      {
        this.duplicateName = true;
        break;
      }
      else {
        this.duplicateName = false; 
      }
    }
    const req = {
      "oauth_realm_id": this.oauthRealmId,
      "name": this.propertyName,
      "value": this.propertyValue,
    }
    if(this.nameError == false && this.valueError == false && this.charNum == false && this.charValue == false && this.duplicateName == false){
    console.log(req,"request")
    this.service.addProperty(req).subscribe((data)=>{
      
      if(data == "Success"){
        this.service.getProperty (this.oauthRealmId).subscribe((data)=> {
          this.property = data
          this.propertyName = null
          this.propertyValue = null
        })
      }
    })
    this.modalService.dismissAll(true);
  }
 
    
  }
  removeProperty(name:any, value:any,id:any){
    const req = {
      "oauth_realm_id": id,
      "name": name,
      "value": value
    }
    console.log(req,"request")
    this.service.deleteProperty(req).subscribe((data)=>{
      window.confirm("Are you sure you want to delete ?")
      if(data == "Success"){
        this.service.getProperty (id).subscribe((data)=> {
          this.property = data
        })
      }
    })
  }


  number(event:any) {
    // var charCode = (event.num) ? event.num : event.keyCode;
    if ((this.propertyName.length > 100)) {
    // event.preventDefault();
    this.charNum = true; 
    // return false;
    } else {
      this.charNum = false; 
    // return true;
    }
    if(this.propertyName == null || this.propertyName == undefined || this.propertyName.length == 0){
      this.nameError = true;
    }
    else{
      this.nameError = false;
    }
    
    }
    value(event:any) {
      // var charCode = (event.num) ? event.num : event.keyCode;
      if ((this.propertyValue.length > 100)) {
      // event.preventDefault();
      this.charValue = true; 
      // return false;
      } else {
        this.charValue = false; 
      // return true;
      }
      if(this.propertyValue == null || this.propertyValue == undefined || this.propertyValue.length == 0){
        this.valueError = true;
      }
      else{
        this.valueError = false;
      }
      }
}

